// Packages
import React from 'react';
import styles from './GuestRegisterPromptModal.module.scss';
import MuiModal, { MuiModalProps } from '../../../mui/MuiModal/MuiModal';
import { Button } from '../../Button';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Icon } from '../../../blocks/icons';
import { handleClose } from '../closeContractSignModalIfOpen';

export type GuestRegisterPromptModalProps = {
	showPaymentText?: boolean;
} & Pick<MuiModalProps['muiModalProps'], 'open' | 'onClose'>;

const GuestRegisterPromptModal: React.FC<GuestRegisterPromptModalProps> = ( {
	showPaymentText,
	open,
	onClose,
} ) => (
	<MuiModal
		muiModalProps={ {
			open,
			onClose: handleClose( onClose ),
			slotProps: {
				paper: { 'data-cy': 'pay-installments-guest-register-modal' },
			},
		} }
		title={
			showPaymentText
				? 'Your payment has been sent.'
				: 'Looking for a simpler way to stay organized?'
		}
		description={ 'A free Rock Paper Coin account can help you:' }
		controls={
			<>
				<Button variant='outlined' onClick={ handleClose( onClose ) }>
					No thanks
				</Button>
				<Button variant='contained' href='/SignUp'>
					Sign up
				</Button>
			</>
		}
	>
		<List>
			<ListItem>
				<ListItemIcon className={ styles.iconContainer }>
					<Icon type='check' className={ styles.icon } />
				</ListItemIcon>
				<ListItemText>
					Keep your proposals, contracts, and invoices in one spot
				</ListItemText>
			</ListItem>
			<ListItem>
				<ListItemIcon className={ styles.iconContainer }>
					<Icon type='check' className={ styles.icon } />
				</ListItemIcon>
				<ListItemText>Save payment methods</ListItemText>
			</ListItem>
			<ListItem>
				<ListItemIcon className={ styles.iconContainer }>
					<Icon type='check' className={ styles.icon } />
				</ListItemIcon>
				<ListItemText>Upload and share files with your vendors</ListItemText>
			</ListItem>
			<ListItem>
				<ListItemIcon className={ styles.iconContainer }>
					<Icon type='check' className={ styles.icon } />
				</ListItemIcon>
				<ListItemText>
					Assign a planner permissions to act on your behalf
				</ListItemText>
			</ListItem>
		</List>
	</MuiModal>
);

export default GuestRegisterPromptModal;
